<template>
  <div style="display: grid;">
    <div class="mb-2" style="margin-left: -24px;">
      <ul class="step-menu">
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Customer Information</div>
        </li>
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <div>Consignee / Shipper</div>
        </li>
        <li role="button" class="d-flex align-items-center">
          <div class="page">3</div>
          <div>Billing Information</div>
        </li>
        <li role="button" class="d-flex align-items-center">
          <div class="page">4</div>
          <div>Required Documents</div>
        </li>
        <li role="button" class="d-flex align-items-center">
          <div class="page">5</div>
          <div>Additional</div>
        </li>
      </ul>
    </div>
    <div class="scroller mt-4" style=";overflow-y: auto;margin-left: 16px;margin-right: 44px;">
      <p style="font-weight: 600;">Import</p>
      <div v-if="isLoadingConsignee" class="_documents__container">
        <half-circle-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
        />
      </div>
      <div v-else>
        <div class="import mb-5" :class="ListConsignee.length < 1 ? 'd-flex align-items-center' : ''">
          <table v-if="ListConsignee.length > 0" class="table">
            <thead>
              <tr style="background: #ECF1F5;font-size: 14px;font-weight: 600;">
                <th scope="col">Consignee Name</th>
                <th scope="col">Country</th>
                <th scope="col">Address</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in ListConsignee" :key="data.name">
                <th width="150" style="font-size: 14px;">{{ data.name ? data.name : ''}}</th>
                <td width="150" style="font-size: 14px;">{{ getCountry(data.id_country)}}</td>
                <td width="250" style="font-size: 14px;word-break: break-all;">{{ data.address ? data.address : '-'}}</td>
                <td width="150" class="text-left">
                  <div>
                    <img
                    class="status-icon"
                    src="@/assets/image/icon/pencil-alt.svg"
                    alt=""
                    height="20px"
                    width="20px"
                    style="line-height: 1.9;cursor: pointer;"
                    @click="addModal('EditConsignee', data)"
                    />
                    <img
                    class="status-icon ml-4"
                    src="@/assets/image/icon/trash.svg"
                    alt=""
                    height="20px"
                    width="20px"
                    style="line-height: 1.9;cursor: pointer;"
                    @click="modalDelete(data.id, 'Consignee')"
                    />
                  </div>         
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else>
            <p class="mr-2">No consignee data available</p>
          </div>
          <button class="btn button-grey mt-2" @click="addModal('Consignee')">
            Add Consignee
          </button>
        </div>
      </div>
      <p style="font-weight: 600;">Export</p>
      <div v-if="isLoadingShipper" class="_documents__container">
        <half-circle-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
        />
      </div>
      <div v-else>
        <div class="export mb-4" :class="ListShipper.length < 1 ? 'd-flex align-items-center' : ''">
          <table v-if="ListShipper .length > 0" class="table">
            <thead>
              <tr style="background: #ECF1F5;font-size: 14px;font-weight: 600;">
                <th scope="col">Shipper Name</th>
                <th scope="col">Country</th>
                <th scope="col">Address</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in ListShipper" :key="data.name">
                <th width="150" style="font-size: 14px;">{{ data.name ? data.name : ''}}</th>
                <td width="150" style="font-size: 14px;">{{ getCountry(data.id_country)}}</td>
                <td width="250" style="font-size: 14px;word-break: break-all;">{{ data.address ? data.address : '-'}}</td>
                <td width="150" class="text-left">
                  <div>
                    <img
                    class="status-icon"
                    src="@/assets/image/icon/pencil-alt.svg"
                    alt=""
                    height="20px"
                    width="20px"
                    style="line-height: 1.9;cursor: pointer;"
                    @click="addModal('EditShipper', data)"
                    />
                    <img
                    class="status-icon ml-4"
                    src="@/assets/image/icon/trash.svg"
                    alt=""
                    height="20px"
                    width="20px"
                    style="line-height: 1.9;cursor: pointer;"
                    @click="modalDelete(data.id, 'Shipper')"
                    />
                  </div>         
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else>
            <p class="mr-2">No Shipper data available</p>
          </div>
          <button class="btn button-grey mt-2" @click="addModal('Shipper')">
            Add Shipper
          </button>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end align-items-center mr-4">
      <button class="btn btn-white-blue mr-2" @click="onSelectedTabBack">Back</button>
      <div class="btn btn-white-blue mr-2" @click="saveDraft">Save Draft</div>
      <button :disabled="(ListConsignee.length < 1 || ListShipper.length < 1)" class="btn btn-white-blue" @click="onSelectedTab">Next</button>
    </div>
    <!-- Modal Component -->
    <b-modal ref="AddModal" id="setting-form-address" centered hide-footer :title="title">
      <div v-if="title === 'Add Consignee' || title === 'Edit Consignee'" class="mb-2">
        <p style="font-weight: 400;font-size: 14px;" class="input-label">Consignee Name<span style="color: red;">*</span></p>
        <b-form-input
          v-model="consignee"
          name="Consignee Name"
          v-validate="'required'"
          placeholder="Enter Consignee Full Name"
        />
        <div class="fontstyle__errormsg">
          {{ errors.first("Consignee Name") }}
        </div>
      </div>
      <div v-else class="mb-2">
        <p style="font-weight: 400;font-size: 14px;" class="input-label">Shipper Name<span style="color: red;">*</span></p>
        <b-form-input
          v-model="shipper"
          name="Shipper Name"
          v-validate="'required'"
          placeholder="Enter Shipper Full Name"
        />
        <div class="fontstyle__errormsg">
          {{ errors.first("Shipper Name") }}
        </div>
      </div>
      <div class="mb-2">
        <p style="font-weight: 400;font-size: 14px;" class="input-label">Country<span style="color: red;">*</span></p>
        <div class="options__multipleselect">
          <multiselect
            v-model="country"
            :options="countryList || []"
            v-validate="'required'"
            label="name"
            placeholder="Selected Country"
            name="Country"
            :allow-empty="false"
            :show-labels="false"
          >
            <span slot="noResult"
              >Oops! No elements found.</span
            >
          </multiselect>
          <img
            class="options__multipleselect--imgabsolute"
            src="@/assets/image/icon/icon-arrow-blue.png"
          />
        </div>
        <div class="fontstyle__errormsg">
          {{ errors.first("Country") }}
        </div>
      </div>
      <div v-if="title === 'Add Consignee' || title === 'Edit Consignee'" class="mb-2">
        <p style="font-weight: 400;font-size: 14px;" class="input-label">Consignee Address<span style="color: red;">*</span></p>
        <b-form-textarea
          v-model="consigneeAddress"
          name="Consignee Address"
          v-validate="'required'"
          type="text"
          placeholder="Jl. Mega Kuningan Barat, Blok E.4.7,"
          rows="9"
          max-rows="6"
          style="max-height: 120px"
        />
        <div class="fontstyle__errormsg">
          {{ errors.first("Consignee Address") }}
        </div>
      </div>
      <div v-else class="mb-2">
        <p style="font-weight: 400;font-size: 14px;" class="input-label">Shipper Address<span style="color: red;">*</span></p>
        <b-form-textarea
          v-model="shipperAddress"
          name="Shipper Address"
          v-validate="'required'"
          type="text"
          placeholder="Jl. Mega Kuningan Barat, Blok E.4.7,"
          rows="9"
          max-rows="6"
          style="max-height: 120px"
        />
        <div class="fontstyle__errormsg">
          {{ errors.first("Shipper Address") }}
        </div>
      </div>
      <div class="d-flex justify-content-center mt-4">
        <button class="button__redsmall mr-2" @click="hide">Cancel</button>
        <button v-if="title === 'Add Consignee' || title === 'Add Shipper'" class="button__bluesmall" @click="postModal">Save</button>
        <button v-else class="button__bluesmall" @click="postModalEdit">Edit</button>
      </div>
    </b-modal>
    <b-modal
      id="modalSuccessUpload"
      ref="modalSuccessPost"
      hide-footer
      hide-header-close
      centered
    >
      <div class="text-center">
        <img class="mb-5" src="@/assets/image/icon/success-blue.svg" alt="">
        <p class="mb-4">{{ (title === 'Add Consignee' || title === 'Add Shipper') ? 'Add Data Success' : 'Edit Data Success'}}</p>
        <button @click="closeSuccessModal" class="button__bluecorporite">Ok</button>
      </div>
    </b-modal>
    <div class="_modals">
      <b-modal
        id="setting-form-address"
        ref="modalConfirm"
        hide-footer
        centered
        :title="`Delete ${title}`"
      >
        <div class="text-center">
          <div class="mb-4">
            <svg width="27" height="29" viewBox="0 0 27 29" fill="none" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="13.5" cy="14.3981" rx="13.5" ry="13.986" fill="#C4232A"/>
              <path d="M14.8321 16.8395H12.8005L12.3758 8.41162H15.2568L14.8321 16.8395ZM12.3425 19.7896C12.3425 19.3066 12.4674 18.9414 12.7172 18.6941C12.967 18.4468 13.3306 18.3232 13.808 18.3232C14.2687 18.3232 14.624 18.4497 14.8738 18.7027C15.1291 18.9558 15.2568 19.3181 15.2568 19.7896C15.2568 20.2439 15.1291 20.6034 14.8738 20.8679C14.6184 21.1267 14.2632 21.2561 13.808 21.2561C13.3417 21.2561 12.9809 21.1296 12.7255 20.8765C12.4702 20.6177 12.3425 20.2554 12.3425 19.7896Z" fill="white"/>
            </svg>
          </div>
          <p class="mb-4" style="font-size: 12px;">
            Are you sure that you want to delete this {{ title }}
          </p>
          <div class="d-flex justify-content-center">
            <button
              @click="closeSuccessModal"
              class="button__redcorporite mr-2"
            >
              No
            </button>
            <button @click="deleteData" class="button__bluecorporite">
              Yes
            </button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'
export default {
  name: 'form2',
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      title: '',
      consignee: '',
      consigneeAddress: '',
      shipperAddress: '',
      shipper: '',
      country: '',
      ListConsignee: [],
      ListShipper: [],
      id: '',
      idData: ''
    }
  },
  computed: {
    ...mapGetters({
      countryList: 'city/country',

      consigneeList: 'settingSaf/consignee',
      errorConsignee: 'settingSaf/errorConsignee',
      isLoadingConsignee: 'settingSaf/isLoadingConsignee',

      shipperList: 'settingSaf/shipper',
      errorShipper: 'settingSaf/errorShipper',
      isLoadingShipper: 'settingSaf/isLoadingShipper'
    })
  },
  async mounted () {
    await this.fetchConsignee()
    await this.fetchShipper()
    await this.fetchCountry()
  },
  methods: {
    async fetchCountry () {
      await this.$store.dispatch('city/FETCH_COUNTRIES')
    },
    async fetchConsignee () {
      await this.$store.dispatch('settingSaf/FETCH_SAF_CONSIGNEE').then(() => {
        if (this.consigneeList) {
          this.ListConsignee = this.consigneeList
        }
      })
    },
    async fetchShipper () {
      await this.$store.dispatch('settingSaf/FETCH_SAF_SHIPPER').then(() => {
        if (this.shipperList) {
          this.ListShipper = this.shipperList
        }
      })
    },
    addModal (type, data) {
      if (type === 'Consignee') {
        this.title = 'Add Consignee'
      } else if (type === 'Shipper') {
        this.title = 'Add Shipper'
      } else if (type === 'EditConsignee') {
        this.title = 'Edit Consignee'
        this.consignee = data.name
        this.countryList.filter((element) => {
          if (element.id === data.id_country) {
            this.country = element
          }
        })
        this.consigneeAddress = data.address
        this.id = data.id
      } else if (type === 'EditShipper') {
        this.title = 'Edit Shipper'
        this.shipper = data.name
        this.countryList.filter((element) => {
          if (element.id === data.id_country) {
            this.country = element
          }
        })
        this.shipperAddress = data.address
        this.id = data.id
      }
      this.$refs['AddModal'].show()
    },
    postModal () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const payload = {
            type: this.title === 'Add Consignee' ? 'CONSIGNEE' : 'SHIPPER',
            countryId: this.country.id,
            name: this.title === 'Add Consignee' ? this.consignee : this.shipper,
            address: this.title === 'Add Consignee' ? this.consigneeAddress : this.shipperAddress
          }
          this.$store.dispatch('settingSaf/POST_SAF_CONSIGNEE', payload).then(() => {
            if (this.title === 'Add Consignee') {
              this.fetchConsignee()
            } else {
              this.fetchShipper()
            }
            this.hide()
            this.$refs['modalSuccessPost'].show()
          })
        }
      })
    },
    async postModalEdit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const payload = {
            type: this.title === 'Edit Consignee' ? 'CONSIGNEE' : 'SHIPPER',
            countryId: this.country.id,
            name: this.title === 'Edit Consignee' ? this.consignee : this.shipper,
            address: this.title === 'Edit Consignee' ? this.consigneeAddress : this.shipperAddress
          }
          this.$store.dispatch('settingSaf/EDIT_SAF_CONSIGNEE', { payload, id: this.id }).then(() => {
            if (this.title === 'Edit Consignee') {
              this.fetchConsignee()
            } else {
              this.fetchShipper()
            }
            this.hide()
            this.$refs['modalSuccessPost'].show()
          })
        }
      })
    },
    modalDelete (id, type) {
      this.$refs.modalConfirm.show()
      this.title = type
      this.idData = id
    },
    async deleteData () {
      await this.$store.dispatch('settingSaf/DELETE_SAF_CONSIGNEE', this.idData).then(() => {
        if (this.title === 'Consignee') {
          this.fetchConsignee()
        } else {
          this.fetchShipper()
        }
        this.$refs.modalConfirm.hide()
      })
    },
    getCountry (data) {
      this.countryList.filter((element) => {
        if (element.id === data) {
          this.dataCountry = element.name
        }
      })
      return this.dataCountry
    },
    closeSuccessModal () {
      this.$refs['modalSuccessPost'].hide()
      this.$refs.modalConfirm.hide()
    },
    hide () {
      this.$refs['AddModal'].hide()
      this.consignee = ''
      this.consigneeAddress = ''
      this.shipperAddress = ''
      this.shipper = ''
      this.country = ''
    },
    onSelectedTab () {
      this.$emit('Next', 'form3')
    },
    onSelectedTabBack () {
      this.$emit('Back', 'form1')
    },
    saveDraft () {
      this.$emit('Draft', '')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/saf/form2.vue